import React from "react";
import { IUIPropertyDefinition, applyAtPath } from "../../../common/common";
import ActionEditorLink, { IAction } from "../../../common/action-editor/ActionEditor";
import { CustomColorPicker, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle, escapeUnit } from "../../../common/ui-props/common";
import IconEditor from "../../../common/icon-selector/IconEditor";
import jp from 'jsonpath'
import { Input } from "uxp/components";
import { createDefaultPropsForWidgetWrapperWithSidebar } from "../../../common/widget-wrappers/WidgetWrapperWithSidebar";

export interface IIconButtonProps {
    icon: string,
    label: string,
    iconColor: string,
    backgroundColor: string,
    onClick?: IAction,
    description?: string,
    labelColor?: string,
    descriptionColor?: string
}

export interface IIconSectionWidgetProps {
    buttons: IIconButtonProps[]
}

export function IconSectionWidgetProperty(widgetProps: IIconButtonProps[], buttonType: string): IUIPropertyDefinition<IIconButtonProps[]> {
    const XPRProps = createDefaultPropsForWidgetWrapperWithSidebar({
       
    }, true)

    return {
        defaults: widgetProps,
        render: (props, uxpContext, data, containerId) => {

            let _props = props?.uiProps || widgetProps
            const { selectedIndex } = data
            const selectedButton = _props[selectedIndex]

            return <>
                <PropertyContainer>
                    <PropertyContainerTitle>Button Properties</PropertyContainerTitle>

                    <PropertyGroup>
                        <PropertyGroupTitle></PropertyGroupTitle>

                        <Property>
                            <PropertyTitle>Icon</PropertyTitle>
                            <IconEditor
                                value={selectedButton?.icon}
                                onChange={s => {
                                    _props[selectedIndex].icon = s
                                    props.onChange(_props)
                                }}
                            />
                        </Property>

                        <Property>
                            <PropertyTitle>Background Color</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData}
                                color={selectedButton?.backgroundColor}
                                onChange={s => {
                                    _props[selectedIndex].backgroundColor = s
                                    props.onChange(_props)
                                }}
                            />
                        </Property>

                        <Property>
                            <PropertyTitle>Icon Color</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData}
                                color={selectedButton?.iconColor}
                                onChange={s => {
                                    _props[selectedIndex].iconColor = s
                                    props.onChange(_props)

                                }}
                            />
                        </Property>

                        <Property>
                            <PropertyTitle>Label</PropertyTitle>
                            <Input
                                value={selectedButton?.label || ''}
                                onChange={s => {
                                    _props[selectedIndex].label = s
                                    props.onChange(_props)

                                }}
                            />
                        </Property>

                        {buttonType == 'rectangle' && <>
                            <Property>
                                <PropertyTitle>Label Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={selectedButton?.labelColor || '#424242'}
                                    onChange={s => {
                                        _props[selectedIndex].labelColor = s
                                        props.onChange(_props)

                                    }}
                                />
                            </Property>

                            <Property>
                                <PropertyTitle>Description</PropertyTitle>
                                <Input
                                    value={selectedButton?.description || ''}
                                    onChange={s => {
                                        _props[selectedIndex].description = s
                                        props.onChange(_props)

                                    }}
                                />
                            </Property>

                            <Property>
                                <PropertyTitle>Description Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={selectedButton?.descriptionColor || '#424242'}
                                    onChange={s => {
                                        _props[selectedIndex].descriptionColor = s
                                        props.onChange(_props)

                                    }}
                                />
                            </Property>

                        </>}

                        <Property>
                            <PropertyTitle>On Click</PropertyTitle>
                            <ActionEditorLink
                                uiProps={props.parentUIProps}
                                action={selectedButton?.onClick}
                                onChange={s => {
                                    _props[selectedIndex].onClick = s
                                    props.onChange(_props)
                                }}
                                uxpContext={uxpContext}
                            />
                        </Property>
                    </PropertyGroup>
                </PropertyContainer>

            </>
        }
    }
}
